module.exports = __webpack_public_path__ + "static/media/20170624-_DSC074209.a96eccda.jpg";